import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
export var GuardZoneState;
(function (GuardZoneState) {
    GuardZoneState[GuardZoneState["GUARD_OFF"] = 0] = "GUARD_OFF";
    GuardZoneState[GuardZoneState["GUARD_ON"] = 1] = "GUARD_ON";
    GuardZoneState[GuardZoneState["ALARM"] = 2] = "ALARM";
})(GuardZoneState || (GuardZoneState = {}));
export var GuardZone;
(function (GuardZone) {
    let StatusFlags;
    (function (StatusFlags) {
        StatusFlags[StatusFlags["ON_GUARD"] = 1] = "ON_GUARD";
        StatusFlags[StatusFlags["TRIGGERED"] = 2] = "TRIGGERED";
        StatusFlags[StatusFlags["TURN_ON"] = 4] = "TURN_ON";
        StatusFlags[StatusFlags["TURN_OFF"] = 8] = "TURN_OFF";
        StatusFlags[StatusFlags["ALARM"] = 16] = "ALARM";
    })(StatusFlags = GuardZone.StatusFlags || (GuardZone.StatusFlags = {}));
    // eslint-disable-next-line no-inner-declarations
    function statusFlagSet(state, flag) {
        return (state.onguard & flag) != 0;
    }
    function isOnGuard(state) {
        return statusFlagSet(state, StatusFlags.ON_GUARD);
    }
    GuardZone.isOnGuard = isOnGuard;
    function isTriggered(state) {
        return statusFlagSet(state, StatusFlags.TRIGGERED);
    }
    GuardZone.isTriggered = isTriggered;
    function isTurnedOn(state) {
        return statusFlagSet(state, StatusFlags.TURN_ON);
    }
    GuardZone.isTurnedOn = isTurnedOn;
    function isTurnedOff(state) {
        return statusFlagSet(state, StatusFlags.TURN_OFF);
    }
    GuardZone.isTurnedOff = isTurnedOff;
    function isAlarm(state) {
        return statusFlagSet(state, StatusFlags.ALARM);
    }
    GuardZone.isAlarm = isAlarm;
    GuardZone.get = createAccessors(arrayGetSet('guard_zones'), {
        name: 'Охранная зона',
        event_delay_time: 0,
        start_delay: 0,
        relative_sensor_list: [],
        relative_triggered_list: [],
        relative_recovered_list: [],
        relative_turned_on: [],
        relative_turned_off: [],
        buzzer_guard_indicator_list: [],
        position: 0,
    });
})(GuardZone || (GuardZone = {}));
